require('angular');

module.exports = angular.module('PwnFMGateConstants', [])
.constant('FMSubscriberStates', {
    SUBSCRIBER_STATUS_ACTIVE: 1,
    SUBSCRIBER_STATUS_UNCONFIRMED: 2,
    SUBSCRIBER_STATUS_UNACTIVE: 3,
    SUBSCRIBER_STATUS_UNSUBSCRIBED: 4,
    SUBSCRIBER_STATUS_SOFT_BOUNCED: 5,
    SUBSCRIBER_STATUS_HARD_BOUNCED: 8
})
.constant('ModalAlerts', {
    UNCONFIRMED: 'Dziękujemy! Na podany adres e-mail przesłaliśmy wiadomość z linkiem do pobrania materiału.',
    UNACTIVE: 'Nie aktywowany',
    UNSUBSCRIBED: 'Ten adres e-mail znajdował się już w systemie. Jednak nasz system odnotował, kliknięcie w link oznaczający, że nie chcesz już otrzymywać od nas żadnej korespondencji. Oznacza to również rezygnację z bezpłatnych wydań Niezbędnika. Czy chcesz otrzymywać od nas korespondencję?',
    BOUNCED: 'Niestety! podany przez Ciebie adres e-mail nie przyjmował wiadomości od nas. Spróbuj proszę podać inny adres.',
    ADDED: 'Na podany adres wysłano link aktywacyjny, prosimy o sprawdzenie szkrzynki i dokonanie aktywacji',
    REQUEST_ERROR: 'Chwilowe przeciążenie sieci. Spróbuj jeszcze raz',
    UNEXPECTED_ERROR: 'Wystąpił niespodziewany błądy. Spróbuj jeszcze raz'
})
.constant('BranchesOfScience', [
    'Biotechnologia medyczna',
    'Biotechnologia przemysłowa',
    'Biotechnologia rolnicza',
    'Biotechnologia środowiskowa',
    'Ekonomia i biznes',
    'Elektrotechnika, elektronika, inżyniera informatyczna',
    'Filozofia etyka i religia',
    'Geografia społeczna i gospodarcza',
    'Historia i archeologia',
    'Inne',
    'Inżynieria chemiczna',
    'Inżynieria lądowa',
    'Inżynieria mechaniczna',
    'Inżynieria medyczna',
    'Inżynieria środowiska',
    'Języki i literatura',
    'Matematyka',
    'Media i komunikowanie',
    'Medycyna kliniczna',
    'Medycyna ogólna',
    'Nanotechnologia',
    'Nauka o zdrowiu',
    'Nauka o zwierzętach i mleczarstwie',
    'Nauki biologiczne',
    'Nauki chemiczne',
    'Nauki fizyczne',
    'Nauki o komputerach i informatyka',
    'Nauki o ziemi i o środowisku',
    'Nauki polityczne',
    'Nauki weterynaryjne',
    'Pedagogika',
    'Prawo',
    'Psychologia',
    'Rolnictwo, leśnictwo i rybołówstwo',
    'Socjologia',
    'Sztuka (sztuka, historia sztuki, sztuki sceniczne, muzyka)'
]);


//////////////////
// WEBPACK FOOTER
// ./vendor/fm_subscription/js/PwnFMGateConstants.js
// module id = 6
// module chunks = 0